import { PropType } from 'vue';

import { Component, Prop, Vue, Mixins } from '@evidentid/vue-property-decorator';

import { AlertType } from './types';

// PRODUCT-26110 Phase 2B2 Task 4: extracted from Alert.vue's <script> block.
// vue-loader 17 wraps every SFC's default export with an `exportHelper()` call that
// stamps `__vccOpts`/`__file` etc. onto a NEW object rather than mutating the class in
// place -- so `class ActionableAlert extends Alert` (importing Alert.vue's default
// export directly) no longer extends a real class at runtime, it extends a plain
// options object with no prototype chain. Extracting the class to a plain .ts file
// (this file) sidesteps the wrapper entirely, matching the repo's existing
// abstract-base convention (AbstractCriterionInput.ts, AbstractJsonSchemaForm.ts, ...:
// `@Component class X extends Vue {} const XMixin = Mixins(X) as typeof X; export
// default XMixin;`). Alert.vue itself now just does `extends AlertBase` too, so both
// Alert.vue's own template and any subclass (ActionableAlert) can extend a real class.
@Component
class AlertBase extends Vue {
    @Prop({ type: String as PropType<AlertType>, default: 'regular' })
    protected type!: AlertType;

    @Prop({ type: String as PropType<string>, default: null })
    protected title!: string | null;

    @Prop({ type: Boolean as PropType<boolean>, default: false })
    protected rounded!: boolean;
}

const AlertBaseMixin = Mixins(AlertBase) as typeof AlertBase;
export default AlertBaseMixin;
